import React from 'react';
import Loader from "../loader";
import Helpers from "../../../../dev/helpers/helperFunctions";
import MatchOfTheDayGame from "../matchOfTheDayGame";
import { t } from "../../../../dev/helpers/translator";
import { MarketContextProvider } from '../gameListAsian/marketContext';
import { GameTypeEnum, GameTypeViewEnum } from '../../../constants/enums/gameType';
import { DrawMarketHeader } from '../../../helpers/asianHelpers';
import Config from '../../../config/main';

const Wrapper = ({ gameType, sportAlias, children }) => {
    if (Config.matchOfTheDayMarkets.length) return <MarketContextProvider gameType={gameType} sportAlias={sportAlias}>
        {children}
    </MarketContextProvider>

    return <>{children}</>
}

export default function matchOfTheDayTemplate() {
    let { loaded, promotedGames, selectorKey, showLiveGames, count } = this.props;

    if (loaded && promotedGames) {
        const games = this.getGamesPerPage(promotedGames);
        const sportAliasList = [...new Set(games.map(game => game.sportAlias))];
        const gameType = GameTypeViewEnum[showLiveGames || !count ? GameTypeEnum.Live : GameTypeEnum.Prematch];

        return (
            <Wrapper gameType={gameType} sportAlias={sportAliasList}>
                <div className="mini-prod-view-t" >
                    <h2>{gameType === "live" ? t("Featured games") :  t("Top Matches")} </h2>
                    {!!Config.matchOfTheDayMarkets.length && <div className="a-title">
                        <div className="live-title"> {showLiveGames ? <p> <span className="live-img"></span> {t('Live Matches')}</p> : <p> <span className="top-img"></span> {t('Top Matches')}</p>}</div>
                        <div className="market-t-v" />
                        <DrawMarketHeader
                            uniqueDisplayKeys={Config.matchOfTheDayMarkets}
                            gameType={gameType}
                            sportAlias={sportAliasList}
                        />
                        <div className="market-t-v" />
                    </div>}
                    <div className="mini-component-wrapper-t">
                        <ul className="f-games-slider">
                            {games.sort((a, b) => a.start_ts-b.start_ts).map(game => <MatchOfTheDayGame game={game} key={game.id} selectorKey={selectorKey} />)}
                        </ul>
                        <div className="slider-arrow-t">
                            <div className={`left-arrow-t ${promotedGames.length <= this.resolution ? "disable-arrow-v" : ""}`} onClick={this.previousPage(promotedGames.length)}>
                                <i className="icon-s-t" />
                            </div>
                            <div className="slider-circle-v">
                                {
                                    Helpers.addPageDots(promotedGames.length, this.resolution, this.state.page)
                                }
                            </div>
                            <div className={`right-arrow-t ${promotedGames.length <= this.resolution ? "disable-arrow-v" : ""}`} onClick={this.nextPage(promotedGames.length)}>
                                <i className="icon-s-t" />
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    } else {
        return <Loader />;
    }
};